<template>
    <div class="content-wrapper">
        <!-- Page Loader -->
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>

        <breadcrumb :page="$t('form.course.edit')"></breadcrumb>

        <div class="content">
            <div class="container-fluid">
                <back-button></back-button>


                <b-alert v-model="showDisableAlert"  variant="info"> {{disableEditFormMessage}}
                    <button v-if="!firstLoad && sessionCreated" @click="checkForEdit(true)">
                         <i class="fas fa-sync"></i>
                    </button>
                </b-alert>

                <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{alertMessage}}</b-alert>

                <div class="card">
                    <form role="form" @submit.prevent="isClone ?saveCourse(): updateCourse()">
                        <div class="card-header bg-light">
                            <div class="card-title">{{$t('form.course.edit')}}</div>
                            <button v-if="isClone" class="btn btn-primary float-right"
                                :disabled="disableEditForm || readonly">{{$t('button.save')}}</button>

                            <div v-else class="text-right">
                                <button class="btn btn-primary"
                                    :disabled="disableEditForm || readonly">{{$t('button.update')}}</button>
                                <button class="btn btn-info" @click="shouldClose = true"
                                    :disabled="disableEditForm || readonly">{{$t('button.updateClose')}}</button>
                            </div>
                        </div>

                        <div class="card-body">

                            <b-tabs content-class="mt-3">
                                <b-tab :title="$t('form.course.tabGeneral')" active>
                                    <div class="form-group row">
                                        <label class="col-sm-3">{{$t('form.course.courseTitle')}}<span
                                                class="text-danger">*</span></label>
                                        <div class="col-sm-9">
                                            <input type="text" class="form-control"
                                                v-model.trim="$v.course.CourseTitle.$model"
                                                :class="{ 'is-invalid': $v.course.CourseTitle.$error }">
                                            <div class="invalid-feedback" v-if="!$v.course.CourseTitle.required">
                                                {{$t('form.validation.required')}}</div>
                                            <div class="invalid-feedback" v-if="!$v.course.CourseTitle.maxLength">
                                                {{$t('form.validation.maxLength', {num: $v.course.CourseTitle.$params.maxLength.max})}}
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group row">
                                        <label class="col-sm-3">{{$t('form.course.courseCode')}}<span
                                                class="text-danger">*</span></label>
                                        <div class="col-sm-9">
                                            <input id="CourseCode" type="text" class="form-control"
                                                v-model.trim="$v.course.CourseCode.$model"
                                                :class="{ 'is-invalid': $v.course.CourseCode.$error }">
                                            <div class="invalid-feedback" v-if="!$v.course.CourseCode.required">
                                                {{$t('form.validation.required')}}</div>
                                            <div class="invalid-feedback" v-if="!$v.course.CourseCode.maxLength">
                                                {{$t('form.validation.maxLength', {num: $v.course.CourseCode.$params.maxLength.max})}}
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group row">
                                        <label class="col-sm-3">{{$t('form.course.SBSCredits')}}<span
                                                class="text-danger">*</span></label>
                                        <div class="col-sm-9">
                                            <input id="SBSCredits" type="number" class="form-control"
                                                v-model.trim="$v.course.SBSCredits.$model"
                                                :class="{ 'is-invalid': $v.course.SBSCredits.$error }">
                                            <div class="invalid-feedback" v-if="!$v.course.SBSCredits.required">
                                                {{$t('form.validation.required')}}</div>
                                            <div class="invalid-feedback" v-if="!$v.course.SBSCredits.maxLength">
                                                {{$t('form.validation.maxLength', {num: $v.course.SBSCredits.$params.maxLength.max})}}
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group row">
                                        <label class="col-sm-3">{{$t('form.course.ECTSCredits')}}<span
                                                class="text-danger">*</span></label>
                                        <div class="col-sm-9">
                                            <input id="ECTSCredits" type="number" class="form-control"
                                                v-model.trim="$v.course.ECTSCredits.$model"
                                                :class="{ 'is-invalid': $v.course.ECTSCredits.$error }">
                                            <div class="invalid-feedback" v-if="!$v.course.ECTSCredits.required">
                                                {{$t('form.validation.required')}}</div>
                                            <div class="invalid-feedback" v-if="!$v.course.ECTSCredits.maxLength">
                                                {{$t('form.validation.maxLength', {num: $v.course.ECTSCredits.$params.maxLength.max})}}
                                            </div>
                                        </div>
                                    </div>
                                </b-tab>

                                <b-tab :title="$t('form.course.tabAudit')">
                                    <b-table id="my-table" :items="audits" :per-page="perPageAudits" sort-by="date"
                                        :sort-desc="true" :current-page="currentPage" :fields="fields" small hover
                                        bordered responsive>
                                    </b-table>

                                    <b-pagination v-if="totalAudits" v-model="currentPage" :total-rows="totalAudits"
                                        :per-page="perPageAudits" aria-controls="my-table" align="center" pills>
                                    </b-pagination>
                                </b-tab>
                            </b-tabs>

                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import {
        required,
        minLength,
        maxLength,
        decimal,
        alpha
    } from "vuelidate/lib/validators";

    export default {
        props: ['permissions', 'editFormInterval', 'datetimeFormat'],

        data() {
            return {
                shouldClose:false,
                isLoading: false,
                fullPage: true,
                isClone:false,

                alert: false,
                alertClass: '',
                alertMessage: '',

                interval: '',
                disableEditFormMessage: '',
                disableEditForm: false,
                closing: true,


                showDisableAlert: false,
                firstLoad:true,
                sessionCreated:true,
                continueInterVal:true,


                // audits custom pagination
                currentPage: 1,
                perPageAudits: 5,
                fields: ['field', 'oldValue', 'newValue', 'userName', 'createdAt'],

                course: {
                    CourseTitle: null,
                    CourseCode: null,
                    ECTSCredits: null,
                    SBSCredits: null
                },

                audits: []
            }
        },

        validations: {
            course: {
                CourseTitle: {
                    required,
                    maxLength: maxLength(255)
                },

                CourseCode: {
                    required,
                    maxLength: maxLength(6)
                },

                ECTSCredits: {
                    required,
                    decimal,
                    maxLength: maxLength(4)
                },

                SBSCredits: {
                    required,
                    decimal,
                    maxLength: maxLength(4)
                }
            }
        },

        mounted() {
            if (!this.permissions.viewCourses) {
                this.$router.push('/');
                return;
            }

            if (this.permissions.editCourses) {
                this.checkForEdit();
                let self = this;
                this.interval = setInterval(() => {
                    if(self.continueInterVal)
                    self.checkForEdit();
                    }, this.editFormInterval);
            }

            this.isClone = this.$route.params.clone;
            this.getAuditsPaginate();
            this.getCourseByID();
            this.getAudits();
        },

        computed: {
            totalAudits() {
                return this.audits.length
            },
            readonly() {
                return !this.permissions.editCourses;
            }
        },

        watch: {
            course: {
                handler(val) {
                    this.closing = false;
                },
                deep: true
            }
        },

        methods: {
            getAuditsPaginate() {
                axios.get('/api/audits-paginate').then(({
                    data
                }) => this.perPageAudits = data);
            },

            showAlert(msg, cls = 'success') {
               this.alertMessage = msg;
                this.alertClass = cls;
                this.alert = true;
            },


            checkForEdit(refresh = false)
            {

                    if(refresh)
                    this.continueInterVal = true;
                    let data= {
                        'field_id':this.$route.params.id,
                        'form':this.$route.name,
                        'refresh':refresh,
                    }
                    // if(refresh) this.showDisableAlert = false;
                    axios
                    .post("/api/check-for-edit-session" , data)
                    .then(response => {

                        this.sessionCreated = true;
                        if (response.data.warning == 0) {

                            this.disableEditForm = false;
                            this.showDisableAlert = false;
                            if(this.firstLoad)
                            {
                                this.firstLoad = false;
                                this.getCourseByID();
                            }
                        }

                        if (response.data.warning == -1) {
                            this.disableEditForm = false ;
                            this.showDisableAlert = false;
                        }

                        if (response.data.warning == 1) {
                             this.firstLoad = false;
                            this.disableEditFormMessage = response.data.message;
                            this.disableEditForm = true;
                            this.showDisableAlert = true;
                            this.continueInterVal = false;
                        }

                        if (response.data.warning == 2) {
                            let msg = response.data.message;
                            if(this.firstLoad){
                              msg.replace('re-open' ,'open');
                            }
                            this.sessionCreated = false;
                            this.disableEditFormMessage = msg;
                            this.disableEditForm = true;
                            this.showDisableAlert = true;
                        }
                        if (response.data.warning == 3) {
                            this.disableEditForm = false;
                            this.showDisableAlert = true;
                            this.disableEditFormMessage = response.data.message;
                        }
                    })
                    .catch(error => {
                        console.log('error');
                    })
                },

            saveCourse() {
                this.$v.$touch();

                if (this.$v.$invalid) {
                    this.showAlert(this.$t('form.validation.error'), 'danger');
                    return;
                }

                this.isLoading = true;

                let formData = new FormData();

                formData.append("course", JSON.stringify(this.course));

                axios
                    .post('/api/courses', formData)
                    .then(response => {
                        this.isLoading = false;

                        if (response.data.error) {
                            this.showAlert(response.data.message, 'danger');
                        }

                        else if (response.data.success) {
                            this.showAlert(response.data.message);

                            setTimeout(() => {
                                this.$router.push({
                                    name: 'CourseIndex'
                                });
                            }, 2000);
                        }
                    })
                    .catch(error => {
                        this.isLoading = false;
                        console.log('error');
                    });
            },

            updateCourse() {
                this.$v.$touch();

                if (this.disableEditForm) {
                    return;
                }

                if (this.$v.$invalid) {
                  
                    let errorMsg = '';
                      if(this.$v.course.CourseTitle.$error){
                            errorMsg = 'Course Title';
                      }

                    if(this.$v.course.CourseCode.$error){
                            errorMsg = errorMsg ? errorMsg +", Course Code": "Course Code";
                      }

                    if(this.$v.course.ECTSCredits.$error){
                            errorMsg = errorMsg ? errorMsg +", ECTS Credits": "ECTS Credits";
                      }

                    if(this.$v.course.SBSCredits.$error){
                            errorMsg = errorMsg ? errorMsg +", SBS Credits": "SBS Credits";
                      }

                    this.showAlert(this.$t('form.validation.mandatoryFieldsError', {errors:errorMsg}), 'danger');
                    return;
                } else {
                    // do your submit logic here
                    this.isLoading = true;
                    axios
                        .put('/api/courses/' + this.$route.params.id, this.course)
                        .then(response => {
                            this.isLoading = false;
                            this.closing = true;

                            if (response.data.success) {

                                this.showAlert(response.data.message);
                               if (this.shouldClose) {
                                    clearInterval(this.interval);
                                    setTimeout(() => this.$router.go(-1), 2000);
                                    return;
                                }

                            }

                            if (response.data.error) {
                                this.showAlert(response.data.message, 'danger');
                            }

                        }, error => {
                            this.isLoading = false;
                            console.log('error');
                        });


                }
            },

            getCourseByID() {
                this.isLoading = true;

                axios
                    .get('/api/courses/' + this.$route.params.id + '/edit')
                    .then(response => {
                        this.course = response.data.course;
                        setTimeout(() => {
                            this.isLoading = false;
                            this.closing = true;
                        }, 1000);
                    })
                    .catch(error => {
                        // console.log(error.response.data);
                        this.isLoading = false;
                    });
            },

            getAudits() {
                axios
                    .get('/api/courses/' + this.$route.params.id + '/audits')
                    .then(response => {
                        this.audits = response.data;
                        this.audits.map(audit => {
                            audit.date = audit.createdAt;
                            audit.createdAt = moment(audit.createdAt).format(this.datetimeFormat);
                        });
                    })
                    .catch(error => {
                        console.log(error.response.data);
                    });
            },

            paginate() {
                this.getAudits();
            }
        },

        beforeRouteLeave(to, from, next) {
            clearInterval(this.interval);

            if (this.closing) next()
            else {
                const answer = window.confirm(this.$t('leavePrompt'))

                if (answer) {
                    next()
                } else {
                    next(false)
                }
            }
        }
    }

</script>
